import React, { useState } from 'react'
import PropTypes from 'prop-types'

import withSiteContext from 'layers/content/v2/Hocs/withSiteContextLegacy'

import K8ProgramRoleTile from './component'
import { connect } from 'react-redux'

const K8ProgramRoleTileContainer = props => {
  const { programPreferences, instructorData } = props || {}
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleModalOpen = () => {
    setIsModalOpen(true)
    // setIsModalLocked(true)
  }
  const handleCloseModal = () => {
    setIsModalOpen(false)
    // setIsModalLocked(false)
  }
  return (
    <K8ProgramRoleTile
      handleCloseModal={handleCloseModal}
      handleModalOpen={handleModalOpen}
      instructorData={instructorData}
      isModalOpen={isModalOpen}
      programPreferences={programPreferences}
    />
  )
}

K8ProgramRoleTileContainer.propTypes = {
  instructorData: PropTypes.object,
  programPreferences: PropTypes.object,
}

const mapStateToProps = state => ({
  instructorData: state?.lmsManager?.instructorData,
})

export default withSiteContext(
  connect(mapStateToProps, null)(K8ProgramRoleTileContainer),
)
